export default {
  install(Vue) {
    function $processMessage(ctx, message, simpleMessage) {
      const messageId = message.type
        ? message.type.split('urn:uuid:')[1]
        : false;

      let mess = '';
      if (!message.type) {
        mess = simpleMessage
          ? message.title
          : ctx.$t('bountyMessages.unknownError');
      } else {
        mess = ctx.$t(`bountyMessages.${messageId}`);
      }

      if (mess && mess.includes('bountyMessages.')) {
        return simpleMessage
          ? message.title
          : ctx.$t('bountyMessages.unknownError');
      } else if (
        !message.parameters ||
        message.parameters === null ||
        Object.keys(message.parameters).length === 0
      ) {
        return mess;
      } else {
        let processedMess = mess;
        Object.keys(message.parameters).forEach(key => {
          let type = message.parameters[key.toLowerCase()];
          if (message.parameters[key.toLowerCase()] === 'comment') {
            type = 'commentOne';
          }
          processedMess = processedMess.replace(
            `{{ ${key.toLowerCase()} }}`,
            ctx.$t(type)
          );
        });

        return processedMess;
      }
    }

    Vue.prototype.$parseErrors = function(errorsArr) {
      const errors = {};
      const setToValue = (obj, path, message) => {
        let i;
        path = path.split('.');
        for (i = 0; i < path.length - 1; i++) {
          if (obj[path[i]] === undefined || typeof obj[path[i]] === 'string') {
            obj[path[i]] = {};
          }
          obj = obj[path[i]];
        }

        obj[path[i]] = $processMessage(this, message);
      };

      errorsArr.forEach(el => {
        setToValue(errors, el.propertyPath, el);
      });

      return errors;
    };

    Vue.prototype.$parseAuthErrors = function(errorsArr) {
      const errors = {};

      errorsArr.forEach(el => {
        errors[el.field] = el.message;
      });

      return errors;
    };

    Vue.prototype.$parseMessage = function(message) {
      const customTextId = '1a4feb44-04b7-445c-97ae-b1341910fdfe';
      const messageId = message.type
        ? message.type.split('urn:uuid:')[1]
        : false;

      return messageId === customTextId
        ? message.title
        : $processMessage(this, message, true);
    };
  }
};
